import TransactionsActionTypes from '../transactions/transactions-types'

const INITIAL_STATE = {
    specialOffers: null,
}

const commonReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case TransactionsActionTypes.FINISH_FAKE_DEPOSIT:
            return {
                ...state,
                specialOffers: { ...state.specialOffers, FAKE_DEPOSIT: true },
            }

        default:
            return state
    }
}

export default commonReducer
